// this is a radio component
// it include the radio button and label
// all the setting is passed in using props
// onChange function is in parent
import React from "react";

const RadioButtons = (props) => {
  // index key value i, j, k
  let i = 0;
  let j = 0;
  let k = 0;


  // this is what json data need to look like,
  // use cleanupData to check the object array for all the fields,
  // if label is empty, set to value
  // if selected is null or empty, set the false
  // let hics_yesno_radios = [
  //    { "id": 1001, "name": "Internal", "activeInd": true, "selected": false },
  //    { "id": 1002, "name": "External", "activeInd": true, "selected": false }
  // ];

  // get props.data from server, update/convert into data, and re-render component
  // data will update every time props update,
  let data = convertData(props.data, props.selectedItem);
  function convertData(ary, selectedItem) {

    //var ary = inputData;

    if (props.value !== undefined && props.value !== null) {
      if (Array.isArray(ary) && ary.length > 0) {
        let newAry = [];
        for (var i = 0; i < ary.length; i++) {
          let id;
          let label;
          let value;
          let selected;
          let name;
          let activeInd;

          // get id, it can be index(if not found) or type of number or type of string
          if (ary[i].id !== undefined || ary[i].id !== null) {
            if (typeof ary[i].id === "number") {
              id = ary[i].id;
            } else {
              id = ary[i].id.toString();
            }
          } else {
            id = i;
          }

          // get value, can be name, or value
          if (ary[i].value !== undefined) {
            value = ary[i].value;
          } else {
            value = ary[i].name;
          }

          // get label, can be either label or name or value or index
          if (ary[i].label !== undefined) {
            label = ary[i].label;
          } else if (ary[i].name !== undefined) {
            label = ary[i].name;
          } else if (ary[i].value !== undefined) {
            label = ary[i].value;
          } else {
            label = i;
          }

          // compare selectedItem
          // get selected, if not found, set to false
          // check input selectedItem, then check if the json has selected field, all else set to false
          //if (!selected_changed) {
          
          if (
            selectedItem !== null &&
            selectedItem !== undefined &&
            selectedItem.id !== null &&
            selectedItem.id !== undefined
            
          ) {
            if (ary[i].id.toString() === selectedItem.id.toString()) {
              selected = true;
              //this.setSelectedValue(value);
              //this.setSelectedLabel(label);
              // selectedId = id;
              // selectedValue = value;
              // selectedLabel = label;
            } else {
              selected = false;
            }
          } else if (ary[i].selected !== undefined) {
            selected = ary[i].selected;
          } else {
            selected = false;
          }

          // get name
          if (ary[i].name !== undefined) {
            name = ary[i].name.toString();
          } else {
            name = "";
          }

          // get activeInd
          if (ary[i].activeInd !== undefined) {
            activeInd = ary[i].activeInd;
          } else {
            activeInd = true;
          }

          newAry.push({
            id: id,
            label: label,
            value: value,
            selected: selected,
            name: name,
            activeInd: activeInd
          });
        }
 

        // on setup, if has selected, return selected, else return []
        props.value(newAry.filter((item) => item.selected === true));

        return newAry;
      } else {

        // set value to empty array
        props.value([]);
        return [];
      }
    } else {

      return [];
    }
  }

  // change from individual radio button,
  // we don't care, we use the group change event
  function justLog(e) {

  }

  // on change event, since it is radio button, it will always have to pick a value
  // event is fire from radio button, e.target.value will carry the value
  // update local value,
  // update parent data
  // sent data to onChange event in parent
  function defaultOnChange(e) {


    // update selected flag in data array and props.data
    for (var i = 0; i < props.data.length; i++) {
      props.data[i].selected = false;
      data[i].selected = false;
    }
    props.data[e.target.getAttribute("index")].selected = true;
    data[e.target.getAttribute("index")].selected = true;

    // return selected value in array
    if (
      props.onChange !== undefined &&
      props.onChange !== null &&
      props.value !== undefined &&
      props.value !== null
    ) {
      // return selected object
      props.value(props.data[e.target.getAttribute("index")]);
      // return selected object
      props.onChange(props.data[e.target.getAttribute("index")]);
    }
  }

  // onblur, this can set value to empty,
  // this event can fire from group
  // e.target.value may not have value
  // fine selected value from the local data
  // return value or empty string
  function defaultOnBlur(e) {


    // onBlur will kick off formik,
    // return selected value or empty {}
    let selectedValue = {};
    if (data.filter((item) => item.selected === true).length > 0) {
      selectedValue = data.filter((item) => item.selected === true)[0];
    }

    if (
      props.onBlur !== undefined &&
      props.onBlur !== null &&
      props.value !== undefined &&
      props.value !== null
    ) {
      props.value(selectedValue);
      props.onBlur(selectedValue);
    }
  }

  // this will change the touched flag in parent for formik
  function defaultOnFocus(e) {

    if (props.onFocus !== undefined && props.onFocus !== null) {
      props.onFocus(true);
    }
  }

  return (
    <div className="inputbox__container">
      <label
        className={`inputbox__label ${
          props.isDisabled ? "inputbox__label--disabled" : ""
        } 
      ${props.hasError ? "inputbox__label--error" : ""}     
`}
        style={{
          display:
            props.label === undefined ||
            props.label === null ||
            props.label.length === 0
              ? "none"
              : "block"
        }}
      >
        {props.label}
        <span
          className={`inputbox__required  ${
            props.isRequired
              ? "inputbox__required--show"
              : "inputbox__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <div><span className="inputbox__help">{props.helpMessage}</span></div>
      <span
        className="inputbox__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>     
      <div
        className={` ${
          props.layoutVertical ? "container--vertical" : "container--horizontal"
        } `}
        onChange={(e) => defaultOnChange(e)}
        onBlur={(e) => defaultOnBlur(e)}
        onFocus={(e) => defaultOnFocus(e)}
      >
        {data.map((item, index) => (
          <div className="radio__item" key={k++}>
            {/* radio button, value=1, group=gender, onChange even = setAnswer */}
            <input
              className="radio__button"
              type="radio"
              id={props.id + "_item_" + i++}
              name={props.name}
              value={item.value}
              checked={item.selected}
              index={index}
              onChange={(e) => justLog(e)}
              disabled={
                props.isDisabled !== undefined && props.isDisabled === true
                  ? true
                  : null
              }
            />
            <label htmlFor={props.id + "_item_" + j++} className="radio__label">
              <span className={` ${
		          props.isDisabled !== undefined && props.isDisabled === true ? "radio__button_label--disabled" : ""
		        } `} >{item.label}</span>
            </label>
          </div>
        ))}
      </div>
      {/**<span className="inputbox__help">{props.helpMessage}</span> */}
    </div>
  );
};

export default RadioButtons;
